import styles from './index.module.scss';
import commonStyles from './../common.module.scss';
import { formatAmount, formatDuration } from '../../../../../utils/index';
import CustomBarChart from "./components/CustomBarChart";
import CustomPieChart from "./components/CustomPieChart";
import { useState } from "react";
import { getTableColumns } from "./services";
import CustomTable from '../CustomTable';
import BonusViewFilter from './components/RatiosViewFilter';
import TableChartFilter, { CHART_VIEW, TABLE_VIEW } from '../TableChartFilter';
import classNames from 'classnames';
import CardContainer from '../CardContainer';
import CardHeader from '../CardHeader';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { getCollaboratorRatios } from '../../../../../api';
import CardBody from '../CardBody';
import RatiosCardSkeleton from './skeleton';

const DISPLAY_OPTIONS = [
  {
    value: 'en',
    label: 'Encodage/Nettoyage'
  },
  {
    value: 'nb',
    label: 'Nettoyage/Bilan'
  },
  // {
  //   value: 'ns',
  //   label: 'Nettoyage/Situation'
  // },
];

export default function RatiosCard({
  collaboratorId,
  selectedPeriod,
  year,
  typeData,
  isActive,
  onAmountChange,
  onLoadingData
}) {
  const { token, navCommunity } = useSelector((state) => state.auth);
  const [dataToDisplay, setDataToDisplay] = useState(DISPLAY_OPTIONS[0].value);
  const [dataView, setDataView] = useState(TABLE_VIEW);
  const [ratiosData, setRatiosData] = useState({
    items: [],
    percentages: {
      en: 0,
      nb: 0,
      // ns: 0
    },
    charts: [],
    totalPercentage: 0
  });
  const [isAchieved, setIsAchieved] = useState(false);
  const [percentage, setPercentage] = useState(0);

  const getCollaboratorRatiosQuery = useQuery(
    [
      "getCollaboratorRatios",
      token,
      navCommunity,
      collaboratorId,
      year,
      selectedPeriod,
    ],
    async () => {
      if (token && navCommunity && collaboratorId) {
        try {
          onLoadingData('rat', true);

          const response = await getCollaboratorRatios({
            token,
            organizationId: navCommunity.id,
            collaboratorId,
            startDate: `${year}-${selectedPeriod.start}`,
            endDate: `${year}-${selectedPeriod.end}`
          });
          let data = response.data.data;
          setRatiosData(prevState => ({
            ...prevState,
            items: data
          }));

          const allItems = data.length;
          const clientsRespectingENRatio = data.filter(item => item.isRespectedEncodageNettoyageRatio).length;
          const clientsRespectingNBRatio = data.filter(item => item.isRespectedNettoyageBilanRatio).length;
          // const clientsRespectingNSRatio = data.filter(item => item.isRespectedNettoyageSituationRatio).length;
          const enPercentage = allItems > 0 ? clientsRespectingENRatio * 100 / allItems : 0;
          const nbPercentage = allItems > 0 ? clientsRespectingNBRatio * 100 / allItems : 0;
          // const nsPercentage = allItems > 0 ? clientsRespectingNSRatio * 100 / allItems : 0;
          // const totalPercentage = (0.8 * enPercentage) + (0.1 * nbPercentage) + (0.1 * nsPercentage);
          const totalPercentage = (0.85 * enPercentage) + (0.15 * nbPercentage);

          setRatiosData((prevState) => ({
            ...prevState,
            percentages: {
              en: enPercentage,
              nb: nbPercentage,
              // ns: nsPercentage
            },
            totalPercentage
          }));

          const enPieChartData = [
            {
              name: 'Les dossiers respectant le ratio 2:1',
              value: Math.round(allItems > 0 ? clientsRespectingENRatio * 100 / allItems : 0)
            },
            {
              name: 'les dossiers ne respectant pas le ratio 2:1',
              value: Math.round(allItems > 0 ?  (allItems - clientsRespectingENRatio) * 100 / allItems : 0)
            }
          ];
          const nbPieChartData = [
            {
              name: 'Les dossiers respectant le ratio 4:1',
              value: Math.round(allItems > 0 ?  clientsRespectingNBRatio * 100 / allItems : 0)
            },
            {
              name: 'les dossiers ne respectant pas le ratio 4:1',
              value: Math.round(allItems > 0 ?  (allItems - clientsRespectingNBRatio) * 100 / allItems : 0)
            }
          ];
          // const nsPieChartData = [
          //   {
          //     name: 'Les dossiers respectant le ratio 4:1',
          //     value: Math.round(allItems > 0 ?  clientsRespectingNSRatio * 100 / allItems : 0)
          //   },
          //   {
          //     name: 'les dossiers ne respectant pas le ratio 4:1',
          //     value: Math.round(allItems > 0 ?  (allItems - clientsRespectingNSRatio) * 100 / allItems : 0)
          //   }
          // ];

          setRatiosData((prevState) => ({
            ...prevState,
            charts: {
              en: enPieChartData,
              nb: nbPieChartData,
              // ns: nsPieChartData
            }
          }));

          // const isAchieved = enPercentage >= 80 && nbPercentage === 100 && nsPercentage === 100;
          const isAchieved = enPercentage >= 80 && nbPercentage === 100;

          setPercentage(totalPercentage);
          setIsAchieved(isAchieved);

          if (isAchieved) {
            onAmountChange('rat', typeData.amount);
          } else {
            onAmountChange('rat', 0);
          }
        } catch (e) {
          console.error(e);
          return null;
        } finally {
          onLoadingData('rat', false);
        }
      }
    }
  );

  const renderEncodageNettoyageTable = () => {
    return (
      <CustomTable
        columns={getTableColumns("nettoyage_1")}
        dataSource={ratiosData.items.map(item => ({
          clientName: item.clientName,
          encodage: formatDuration(item.encodage),
          nettoyage_1: formatDuration(item.nettoyage_1),
          ratio: formatAmount(item.encodageNettoyageRatio, false),
        }))}
      />
    );
  };

  const renderNettoyageBilanTable = () => {
    return (
      <CustomTable
        columns={getTableColumns("bilan")}
        dataSource={ratiosData.items.map(item => ({
          clientName: item.clientName,
          nettoyage: formatDuration(item.nettoyage),
          bilan: formatDuration(item.bilan),
          ratio: formatAmount(item.nettoyageBilanRatio, false),
        }))}
      />
    );
  };

  // const renderNettoyageSituationTable = () => {
  //   return (
  //     <CustomTable
  //       columns={getTableColumns("situation")}
  //       dataSource={ratiosData.items.map(item => ({
  //         clientName: item.clientName,
  //         nettoyage: formatDuration(item.nettoyage),
  //         situation: formatDuration(item.situation),
  //         ratio: formatAmount(item.nettoyageSituationRatio, false),
  //       }))}
  //     />
  //   );
  // };

  const renderEncodageNettoyageCharts = () => {
    return (
      <div className={styles.charts}>
        <div className={styles.bar_chart}>
          <CustomBarChart
            data={ratiosData.items.map(item => ({ name: item.clientName, ratio: item.encodageNettoyageRatio }))}
            chartName="Encodage/Nettoyage Ratio"
            referenceLineY={2}
          />
        </div>
        <div className={styles.pie_chart}>
          <CustomPieChart data={ratiosData.charts.en} />
        </div>
      </div>
    );
  };

  const renderNettoyageBilanCharts = () => {
    return (
      <div className={styles.charts}>
        <div className={styles.bar_chart}>
          <CustomBarChart
            data={ratiosData.items.map(item => ({ name: item.clientName, ratio: item.nettoyageBilanRatio }))}
            chartName="Nettoyage/Bilan Ratio"
            referenceLineY={4}
          />
        </div>
        <div className={styles.pie_chart}>
          <CustomPieChart data={ratiosData.charts.nb} />
        </div>
      </div>
    );
  };

  // const renderNettoyageSituationCharts = () => {
  //   return (
  //     <div className={styles.charts}>
  //       <div className={styles.bar_chart}>
  //         <CustomBarChart
  //           data={ratiosData.items.map(item => ({ name: item.clientName, ratio: item.nettoyageSituationRatio }))}
  //           chartName="Nettoyage/Situation Ratio"
  //           referenceLineY={4}
  //         />
  //       </div>
  //       <div className={styles.pie_chart}>
  //         <CustomPieChart data={ratiosData.charts.ns} />
  //       </div>
  //     </div>
  //   );
  // };

  const renderContent = () => {
    if (dataToDisplay === 'en') {
      switch(dataView) {
        case TABLE_VIEW: return renderEncodageNettoyageTable();
        case CHART_VIEW: return renderEncodageNettoyageCharts();
        default: return null;
      }
    } else if (dataToDisplay === 'nb') {
      switch(dataView) {
        case TABLE_VIEW: return renderNettoyageBilanTable();
        case CHART_VIEW: return renderNettoyageBilanCharts();
        default: return null;
      }
    }
    // else if (dataToDisplay === 'ns') {
    //   switch(dataView) {
    //     case TABLE_VIEW: return renderNettoyageSituationTable();
    //     case CHART_VIEW: return renderNettoyageSituationCharts();
    //     default: return null;
    //   }
    // }

    return null;
  };

  if (getCollaboratorRatiosQuery.isFetching) {
    return (
      <RatiosCardSkeleton />
    );
  }

  return (
    <CardContainer className={classNames({
      [styles.card]: true,
      [commonStyles.card_blured]: !isActive
    })}>
      {!isActive && (
        <div className={commonStyles.blured_text}>
          Ce type de bonus n’est pas configuré pour la période choisie.
        </div>
      )}
      <CardHeader
        percentage={formatAmount(
          percentage,
          false
        )}
        amount={typeData.amount}
        title={typeData.label}
        isPositif={isAchieved}
        detailsBoxes={[
          {
            value:
              (ratiosData.percentages.en === 0
                ? 0
                : formatAmount(ratiosData.percentages.en, false)) +
              "%",
            label: "Encodage/Nettoyage",
            description: "2:1",
            isPositif: ratiosData.percentages.en >= 80,
          },
          {
            value:
              (ratiosData.percentages.nb === 0
                ? 0
                : formatAmount(ratiosData.percentages.nb, false)) +
              "%",
            label: "Bilan/Nettoyage",
            description: "5:1",
            isPositif: ratiosData.percentages.nb === 100,
          },
          // {
          //   value:
          //     (ratiosData.percentages.ns === 0
          //       ? 0
          //       : formatAmount(ratiosData.percentages.ns, false)) +
          //     "%",
          //   label: "Nettoyage/Situation",
          //   description: "4:1",
          //   isPositif: ratiosData.percentages.ns === 100,
          // },
        ]}
      />
      <CardBody title={typeData.description}>
        <div className={styles.container}>
          <div className={styles.content}>
            <div className={styles.filters}>
              <TableChartFilter
                onChange={(selectedView) => {
                  setDataView(selectedView);
                }}
              />
              <BonusViewFilter
                options={DISPLAY_OPTIONS}
                onChange={(inputValue) => setDataToDisplay(inputValue)}
              />
            </div>

            {renderContent()}
          </div>
        </div>
      </CardBody>
    </CardContainer>
  );
}
